import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrdersRouterService } from 'src/app/services/api/router/orders-router.service';
import { TabObject } from 'src/app/models/orders/item/tab-object.model';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { TabListObject } from 'src/app/models/orders/item/tab-list-object.model';
import { TabIndexObject } from 'src/app/models/orders/item/tab-index-object.model';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';

@Component({
  selector: 'app-order-cfs',
  templateUrl: './order-cfs.component.html',
  styleUrls: ['./order-cfs.component.scss']
})
export class OrderCfsComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();

  private tabList: TabListObject;
  selectedIndex;

  constructor(private routerService: OrdersRouterService) {

  }

  ngOnInit() {
    this.tabList = new TabListObject();
    this.tabList.add(new TabIndexObject(0, TabObject.GENERAL_TAB));
    this.tabList.add(new TabIndexObject(1, TabObject.SERVICE_TAB));
    this.tabList.add(new TabIndexObject(2, TabObject.PROCESSES_TAB));
    this.tabList.add(new TabIndexObject(3, TabObject.SITES_TAB));
    this.tabList.add(new TabIndexObject(4, TabObject.DEPENDENCIES_TAB));
    switch (this.params.tab) {
      case 'general':
        this.selectedIndex = 0;
        break;
      case 'service':
        this.selectedIndex = 1;
        break;
      case 'processes':
        this.selectedIndex = 2;
        break;
      case 'sites':
        this.selectedIndex = 3;
        break;
      case 'dependencies':
        this.selectedIndex = 4;
        break;
      default:
        this.selectedIndex = 0;
        break;
    }
  }

  public goToTab($event): void {
    const tab: TabObject = this.tabList.getTab($event.index);

    this.routerService.navigate(new ItemObject(this.params.id, this.params.map, OrderTypeObject.CFS, tab));

  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }
}